export default "__VITE_ASSET__DeAszH63__"